import React from "react";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import OptionChainBasketTbl from "./optionChainBasketTbl";
import AdvanceCharts from "./advance";

const Basketindex = ({basketTabs, warpHeight, dragging, buySellClick, inputValues, getInputValues, info, width, height, windowScreen, atmPrice, strikeCE, strikePE, separatorProps, handleEditBasketOrder}) => { 
  return (
    <div
      style={{
        height: height,
        padding: 0,
        position: "relative",
      }}
    >
      <div>
        <div className="d-flex justify-content-between px-1 mb-2 ">
          <Tabs style={{ width: "100%" }}>
              {basketTabs === 1 && height && (
            <TabPanel>
                <AdvanceCharts
                  dragging={dragging}
                  buySellhandle={buySellClick}
                  getInputValues={getInputValues}
                  strikeCE={strikeCE}
                  strikePE={strikePE}
                  atmPrice={atmPrice}
                  info={info}
                  inputValues={inputValues}
                  height={(height - 175) > 0 ? height - 45 : 50}
                  width={width}
                  windowScreen={windowScreen}
                />
            </TabPanel>
              )}
              {basketTabs === 2 && (
            <TabPanel className={'active'}>
                <OptionChainBasketTbl
                  info={info}
                  inputValues={inputValues}
                  height={height}
                  width={width}
                  windowScreen={windowScreen}
                  handleEditBasketOrder={handleEditBasketOrder}
                />
            </TabPanel>
              )}
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Basketindex;
